/**
 * Game domain links configuration
 * Links to different game variants
 */

import { getGameLinkName } from '../i18n/helpers';

export interface GameLink {
  id: 'blitz' | 'team' | 'family' | 'party' | 'coop' | 'new';
  name: string;
  url: string;
}

const GAME_LINK_URLS: Record<string, { id: GameLink['id']; url: string }> = {
  blitz: { id: 'blitz', url: 'https://blitz.toyo.games' },
  team: { id: 'team', url: 'https://team.toyo.games' },
  family: { id: 'family', url: 'https://family.toyo.games' },
  party: { id: 'party', url: 'https://party.toyo.games' },
  coop: { id: 'coop', url: 'https://coop.toyo.games' },
  new: { id: 'new', url: 'https://new.toyo.games' },
};

function toGameLink(id: GameLink['id'], url: string): GameLink {
  return { id, url, name: getGameLinkName(id) };
}

export const GAME_LINKS: Record<string, GameLink> = Object.fromEntries(
  Object.entries(GAME_LINK_URLS).map(([key, { id, url }]) => [key, toGameLink(id, url)])
) as Record<string, GameLink>;

/**
 * Get all game links except the current one
 */
export function getOtherGameLinks(currentGameType?: GameLink['id']): GameLink[] {
  return Object.values(GAME_LINK_URLS)
    .filter((link) => link.id !== currentGameType)
    .map(({ id, url }) => toGameLink(id, url));
}

/**
 * Get game links for menu (excluding coop for now)
 */
export function getMenuGameLinks(currentGameType?: GameLink['id']): GameLink[] {
  return Object.values(GAME_LINK_URLS)
    .filter((link) => link.id !== 'coop' && link.id !== currentGameType)
    .map(({ id, url }) => toGameLink(id, url));
}
